<template>
  <div class="row">
    <div id="loginImage" class="col-lg-6 h-100 position-fixed"></div>
    <div class="col-md-12 col-lg-6 offset-lg-6">
      <div class="container text-center">
        <div class="contenedor">
          <div class="col-md-10 col-lg-8 offset-md-1 offset-lg-2">
            <h2>Comité de Crédito Digital</h2>
            <h5>Bienvenido, por favor inicia sesión con tu cuenta</h5>
            <div class="formLogin mt-5">
              <form @submit.prevent="iniciarSesion">
                <div class="form-floating mt-5">
                  <input
                    type="email"
                    class="form-control"
                    id="floatingCorreo"
                    v-model="usuario"
                    placeholder="Correo electrónico"
                    required
                  />
                  <label for="floatingCorreo">Correo electrónico</label>
                </div>
                <div class="form-floating mt-4 mb-5" id="contrasena">
                  <input
                    type="password"
                    class="form-control"
                    id="floatingPassword"
                    v-model="clave"
                    placeholder="Contraseña"
                    required
                  />
                  <label for="floatingPassword">Contraseña</label>
                </div>
                <div class="espacio d-flex mb-5">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkSesion"
                    />
                    <label class="form-check-label" for="checkSesion">
                      Recordar mi cuenta
                    </label>
                  </div>
                  <router-link :to="{ name: 'Recuperacion' }" class="ms-auto"
                    >Olvidé mi contraseña</router-link
                  >
                </div>
                <div class="row espacio">
                  <button
                    type="submit"
                    class="
                      btn btn-primary
                      rounded-pill
                      col-sm-8 col-md-6
                      offset-sm-2 offset-md-3
                    "
                    v-if="!cargando"
                  >
                    Iniciar sesión
                  </button>
                  <div class="text-center" v-else>
                    <pulse-loader
                      :loading="cargando"
                      :color="'#FFA000'"
                      :size="'25px'"
                    ></pulse-loader>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-12 offset-md-2">
            <footer class="col-md-8">
              <p>
                Términos y Condiciones son aplicables al uso de los servicios
                ofrecidos por Autofinanciamiento Nacional, S.A. de C.V. y Bienes
                Programados, S.A. de CV.
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import ConnectionHub from "@/conexionHub.js";

export default defineComponent({
  name: "Login",

  components: {
    PulseLoader,
  },

  data() {
    return {
      cargando: false,
      usuario: "",
      clave: "",
      respuesta: "",
    };
  },

  methods: {
    async iniciarSesion() {
      this.cargando = true;
      var usuarioDto = {
        Usuario: this.usuario,
        Contrasenia: this.clave,
      };
      await this.axios
        .post("Usuario/Login", usuarioDto)
        .then((response) => {
          this.respuesta = response.data;

          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.$router.push({
              name: "ListaPrincipal",
              params: { estatus: "2" },
            });

            //ConnectionHub.start().then(function () {

            //    ConnectionHub.invoke("CargarUsuario").catch(function (err) {
            //        return console.error(err.toString());
            //    });

            //}).catch(function (err) {
            //    return console.error(err.toString());
            //});
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje:
              error == "Error: Network Error" ? "Error de conexión" : error,
          });
        })
        .finally(() => (this.cargando = false));
    },
  },
});
</script>

<style scoped>
#loginImage {
  /*background: linear-gradient(223.15deg, #242348 12.21%, #5A55AA 83.68%);*/
  background-image: url("../../public/img/login.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  width: 50%;
  height: 100%;
}

h2 {
  margin-top: 25%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 35px;
  line-height: 43px;
  color: #151965;
  font-weight: 700;
}

h5 {
  margin-top: 20px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #302d74;
  opacity: 0.5;
}

label {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #151965;
}

button {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  height: 40px;
}

#floatingCorreo,
#floatingPassword {
  border: 0;
  border-bottom: solid 2px #e9e9f0;
}

footer {
  font-size: 12px;
  font-weight: 400;
  color: #43425d;
  margin: 15px 0px;
}

.contenedor {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}
.checkSesion {
  border: solid 1px #ffa000;
}

.error {
  color: rgb(211, 0, 0);
}

@media (max-width: 992px) {
  #loginImage {
    display: none;
  }
}
</style>
